import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../Modal';
import * as modal from '../../reducers/modalReducer';
import RaisedButton from 'material-ui/RaisedButton';
import styled from 'styled-components';
import { getSpecificIcon } from '../../helpers/producttypes.js';

import { rootPageUri, ordersHistoryUri} from '../../config/uri';
import { hideViewDetail } from '../../actions/product'
import './style.css';

import { HeaderDiv } from '../../modals';
import { pushWithQueryParams } from '../../services/uri';

const styles = {
  closeIcon: { "position":"absolute",top:0,"right":"0","margin":"8px 5px 0 0" },
  labelStyle: {fontWeight:700}
};

class CheckoutErrorModal extends Component {
    isNextBtnClicked: false;
    secondaryColor = `#` + this.props.secondaryColor;
    modalStyle = {};

    componentWillMount() {
      if (!this.props.isSuccess) return;
      setTimeout(() => {
          this.onCloseRequest();
      }, 1000)
    }

    onCloseRequest = () => {
      if (this.isNextBtnClicked) return;
        this.props.hideModal();
    }

    handleOrderHistoryClick = (orderId) => {
      this.props.hideModal();
      this.props.openOrderHistory(ordersHistoryUri.replace(':orderId', orderId))
    }

    handleNextClick = () => {
        this.isNextBtnClicked = true;
        this.props.hideModal();
        this.props.hideViewDetail();
        if (this.props.orderStatus) {
          this.props.openOrderComplete({
            hideModal: this.props.hideModal,
            openMainPage: this.props.openMainPage,
            secondaryColor: this.secondaryColor,
            openOrderHistory: this.handleOrderHistoryClick.bind(null, this.props.orderId),
            eta: this.props.eta
          });
        } else {
          this.props.hideModal();
          this.props.openMainPage();
        }
    }

  getIcon = (name, isChecked) => {
    return getSpecificIcon(name, '#616161');
  }

    renderProducts() {
      const { products } = this.props;
      if (!products) return null;
      const res = products.map((item, index) => {
        return (
          <div key={index} className="checkout-item">
            <div className="checkout-item-left">
              <span className="checkout-purchase-type-icon">{this.getIcon(item.type.toUpperCase())}</span>
              <div className="checkout-treezcart-item-qnt ">{item.quantity} <span className="chekout-treezcart-item-qnt-title">qty.</span></div>
            </div>
            <div className="checkout-item-right">
              <div className="checkout-item-brand treezcart-item-brand">{item.brand}</div>
              <div className="checkout-item-name treezcart-item-name">{item.name}</div>
              <div className="treezcart-item-size-wrapper">
                  <span className="treezcart-item-pricesell">
                    <div className="checkout-price treezcart-item-weight"><b>${item.priceSell}</b> - {item.weight}g</div>
                  </span>
              </div>
            </div>
          </div>);
      });
      return res;
    }
 
  render() {
    return (
      <Modal 
        style={this.modalStyle} 
        overlayTop={0} 
        paddingTop={100} 
        closeOnOutsideClick={true} 
        isOpened={true}
        onClose={this.onCloseRequest}>
        <ModalWrapperDiv className="checkout-error">
            <HeaderDiv className="header">SORRY!</HeaderDiv>
            <div className="sub-header">
              {
                this.props.strictMedCustomerWithRecItems
                  ? 'Strict medical customers cannot purchase recreational inventory.'
                  : 'We are out of stock of the following item(s):'
              }
            </div>
            <div className="checkout-products-container">
              {this.renderProducts()}
            </div>
            <ButtonsWrapperDiv>
               <RaisedButton
                  onClick={this.handleNextClick}
                  backgroundColor={`#` + this.props.secondaryColor}
                  labelColor="#FFF"
                  label="Ok"
                  labelStyle={styles.labelStyle}
                />
            </ButtonsWrapperDiv>
        </ModalWrapperDiv>
       </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor,
    cart: state.cart
  };
};

const mapDispatchToProps = (dispatch) => {
  return { 
      hideModal: () => dispatch(modal.hideModal()),
      openSignUpForm: () => dispatch(modal.openModal({
        modalType: 'SIGNUP_FORM',
        modalProps: {}
      })),
      openOrderComplete: (props) => dispatch(modal.openModal({
        modalType: 'ORDER_COMPLETE_FORM',
        modalProps: props
      })),
      openMainPage: () => dispatch(pushWithQueryParams(rootPageUri)),
      hideViewDetail : () => dispatch(hideViewDetail()),
      openOrderHistory: (url) => dispatch(pushWithQueryParams(url)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutErrorModal);

const ModalWrapperDiv = styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    height: 100%;
    font-family: 'Futura-Bold',  sans-serif;
`;


const ButtonsWrapperDiv = styled.div `
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
`;




// WEBPACK FOOTER //
// ./src/components/CheckoutErrorModal/CheckoutErrorModal.jsx